import * as configcat from 'configcat-js';

const logger = configcat.createConsoleLogger(3); // Setting log level to 3 (Info)

export const configCatClient = configcat.createClientWithManualPoll(
  import.meta.env.VITE_CONFIG_CAT_API_KEY as string,
  {
    logger: logger,
  }
);
